// extracted by mini-css-extract-plugin
module.exports = {"disclaimerContainer":"DisclaimerContainer_disclaimerContainer__xhPB6"};